import calificationReducer from './calificationReducer';
export default calificationReducer;